export enum types {
	login = '[auth] Login',
	logout = '[auth] Logout',
}
